import Mutations from '../../odata/mutations';

export default { ...new Mutations('skillItem'), ...new Mutations('skillItems') };
